import React, { useEffect, useState } from 'react';
import { Text, View, TouchableOpacity, StyleSheet } from 'react-native';

import styled, { useTheme } from 'styled-components/native';
import {BasicText, FlexBlock, FlexBlockWrapped, Heading3, Loading, StrongText, MetricStackTitle, AppShellStyle, ShinyBlockOuter, ShinyBody, ShinyHeading } from './Styles'
import { COLORS } from '../WasteTheme';
import { Icon } from './index';
import { CircleChart, DiversionHistogram, MaterialGraph, niceRound} from './Things';
import { RankBlock } from './Summary';
import _ from 'lodash';
import OpidLink from './core/OpidLink';
import withHover from './core/withHover';
import Metrics, { Metric, MetricStack as MetricsMetricStack } from './core/Metrics';
import { List as CoreList } from './core/List';

export default function TestingLayout({portalData, currentMonth}){
    const theme = useTheme();

    let thisMonth = null;

    if (portalData.materials == null){
        return <Loading>loading</Loading>
    }

    if (portalData.materials){
        thisMonth = portalData.materials.filter((r)=>r.date == currentMonth);
    }

    if (theme.screen == 'desktop'){
    }

    let totalMT = 0;
    const materialsOverview = thisMonth.map( (m)=>{
        totalMT += m.metric_tonnes;

        let delta = 0;
        if(m.name.indexOf("Organic") > -1){
            delta = -5;
        }
       return <Metric key={m.id} title={m.name} value={niceRound(m.metric_tonnes,2) + " MT"} icon={m.icon || "trash"} delta={delta}/>
    });
    // return <Metric key={m.} title="Carboard" value="3 MT" icon="trash"/>
    // <Metric title="Waste" value="4.5 MT" icon="trash"/>)

    materialsOverview.unshift(<Metric key="all" title="All Materials" value={niceRound(totalMT,2) + " MT"} icon="trash"/>);

    return <View>
        <FlexBlockWrapped>
        <MetricStack>
            <Metric title="Landfill Diversion" value="30 MT" icon="trash" delta={22}/>
            <Metric title="Greenhouse Gas" value="60 MT CO₂ Saved" icon="cloud" delta={10}/>
        </MetricStack>

        <MetricStack>
            <Metric title={"Cost Savings"} value={"$1745"} testValue={calculate(thisMonth, 'savings')} icon="hand-holding-usd" delta={14}/>
            <Metric title="Cost Avoidance" value="$2400" icon="dollar-sign" delta={20}/>
            <Metric title="Overall Costs" value="$13000" icon="money-bill" delta={17}/>
        </MetricStack>

        <MetricStack defaultSelectedTitle="Organics">
            {materialsOverview}
        </MetricStack>

        </FlexBlockWrapped>

        <FlexBlockWrapped direction="row" flexGrow={1}>

            <FlexBlockWrapped direction="column" flexGrow={1} minWidth={250}>
                <ShinyBlockOuter flex={2} minHeight={400}>
                    <ShinyHeading>
                        <MetricStackTitle>{"Historical Diversion"}</MetricStackTitle>
                    </ShinyHeading>
                    <ShinyBody>
                        <DiversionHistogram data={ portalData.diversion } maxValue={20}/>
                        
                    </ShinyBody>
                </ShinyBlockOuter>

                <ShinyBlockOuter flex={1} minHeight={300}>
                    <ShinyHeading>
                        <MetricStackTitle>{"Material Composition"}</MetricStackTitle>
                    </ShinyHeading>
                    <ShinyBody>
                        <MaterialGraph data={thisMonth} units="MT"/>
                    </ShinyBody>
                </ShinyBlockOuter>
            </FlexBlockWrapped>

            <MetricStack flexGrow={15}>
                <DiversionSummary title={"Landfill Diversion"} portalData={portalData} currentMonth={currentMonth}/>
                <RankBlock siteView="Diversion" title="Site Rankings By Diversion" portalData={portalData} currentMonth={currentMonth} topRanking={5} topRankingField="diversion_percent"/>
            </MetricStack>
        </FlexBlockWrapped>
    </View>;

{/* <MetricStack flexGrow={15}>
<RankBlock siteView="Savings" title="Site Rankings By Savings" portalData={portalData} currentMonth={currentMonth}/>
<RankBlock siteView="Diversion" title="Landfill Diversion Ranking" portalData={portalData} currentMonth={currentMonth}/>
<RankBlock siteView="Carbon Reduction" title="Carbon Reduction Ranking" portalData={portalData} currentMonth={currentMonth}/>
</MetricStack> */}
}

const  DiversionSummary =({portalData, currentMonth})=>{
    return <View>
            <Heading3>Average Diversion (All Sites)</Heading3>
            <CircleChart title="Pie Chart" data={ [
                {id: "waste", icon: "garbage", fType: "fac", label: 'Waste', color: COLORS.blackish, value: 100, },
                {id: "recycle", icon:'recycle', label: 'Mixed Recyclables', color: COLORS.wsc_blue, value: 68}, 
                {id: "organics", icon:'organics', fType: "fac", label: 'Organics', color: COLORS.acid_green, value: 68}]  } units="MT" centeredMetric="55%"></CircleChart>

            <Heading3>Top 5 Sites</Heading3>
            <RankBlock siteView="DiversionSmall" title="Top 5 Sites" portalData={portalData} currentMonth={currentMonth} topRanking={5} topRankingField="diversion_percent"/>
            
            <OpidLink path="/site/comparison"><StrongText>Site Comparison</StrongText></OpidLink>
    </View>
}  

export function MetricStack({children, title="", defaultSelectedTitle="", flexGrow=1, flexBasis=null, style={}, allowFavourites=false}){
    return <MetricsMetricStack title={title} defaultSelectedTitle={defaultSelectedTitle} flexGrow={flexGrow} flexBasis={flexBasis} style={style} allowFavourites={allowFavourites}>
        {children}
    </MetricsMetricStack>;
}

export function AppShell({children}){
    return <AppShellStyle>
        {children}
    </AppShellStyle>
}

function calculate(thisMonth, arg1) {
    if (thisMonth.length > 0){
        //debugger;
    }
}

export const List = ({children = (data)=> { console.log(data); }, data, resultsPerPage = 8, page = 0}) => {
    return <CoreList data={data} resultsPerPage={resultsPerPage} page={page}>
        {children}
    </CoreList>
}

export const TestCrazy = ()=>{
    return <ShinyBlockOuter minHeight={400}>
        <ShinyHeading>
            <MetricStackTitle>{"Sites"}</MetricStackTitle>
        </ShinyHeading>
        <ShinyBody>
            <View style={{ height: 600, backgroundColor: 'red' }}><Text>WTF</Text></View>
        </ShinyBody>
    </ShinyBlockOuter>;
}

